
import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { setSelectedKPIConfig } from '@store/overviewDashboard/spiThresholds/actions';
import { useDispatch } from 'react-redux';
import { SPIMetricsDropDown } from '../styled';

const KPIValues = ({ config, selectedKPIConfig, selectedKPIConfigID }) => {
  const dispatch = useDispatch();

  const [selectedName, setSelected] = useState(selectedKPIConfig.kpiName);

  useEffect(() => {
    setSelected(selectedKPIConfig.kpiName);
  }, [selectedKPIConfigID, selectedKPIConfig]);

  const renderSelect = () => {
    const items = config.map(item => ({
      key: item.kpiID,
      displayValue: item.kpiName,
    }));
    const { Option } = Select;
    const options = items.map((item, index) => (<Option key={index} value={item.key}>{item.displayValue}</Option>));
    return (
      <Select
        key={selectedName}
        style={{ width: '100%' }}
        value={selectedName}
        onChange={onChange}
      >
        {options}
      </Select>
    );
  };

  const onChange = (value) => {
    const currentConfig = config.find(item => item.kpiID === value);
    dispatch(setSelectedKPIConfig(currentConfig));
  };

  return (
    <SPIMetricsDropDown>
      {renderSelect()}
    </SPIMetricsDropDown>
  );
};

export default KPIValues;
